// src/components/ContactSection.jsx
import React, { useState } from "react";

export default function ContactSection() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    eventType: "",
    eventDate: "",
    guestCount: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch("https://pixlybooth.taswog.com/contact.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });

    const data = await res.json();

    if (data.success) {
      alert("Thank you! Your request has been sent. We'll contact you shortly.");
      setForm({
        name: "",
        email: "",
        phone: "",
        eventType: "",
        eventDate: "",
        guestCount: "",
        message: "",
      });
    } else {
      alert(data.message || "Something went wrong. Please try again.");
    }
  } catch (err) {
    alert("Network error. Please try again later.");
  }
};

  return (
    <section
      id="contact"
      className="py-20 bg-gradient-to-b from-[#05030D] via-[#070A18] to-[#05030D] text-white"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="rounded-[32px] p-[1px] bg-gradient-to-r from-[#FF4C86] via-[#9F5CFF] to-[#3B1D7A] shadow-[0_30px_80px_rgba(0,0,0,0.85)] animate-fade-up">
          <div className="rounded-[30px] bg-[#060719]/95 backdrop-blur-xl px-6 py-8 md:px-10 md:py-10 flex flex-col lg:flex-row gap-8">
            {/* LEFT CONTENT */}
            <div className="lg:w-2/5 flex flex-col justify-between">
              <div>
                <p className="text-[11px] uppercase tracking-[0.3em] text-pink-200 mb-2">
                  Let’s Plan Your Event
                </p>
                <h2 className="text-2xl md:text-3xl font-bold mb-3">
                  Book Your Booth Today!
                </h2>
                <p className="text-sm md:text-base text-pink-100 max-w-md">
                  Spots fill fast — share a few details about your event and our
                  team will get back to you with availability and recommendations
                  within 24 hours.
                </p>
              </div>

              <div className="mt-6 text-xs text-pink-100/80 space-y-1">
                <p>📍 Serving: Weddings, corporate events & private parties.</p>
                <p>⏱ Typical reply time: under 24 hours.</p>
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="lg:w-3/5">
              <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs md:text-sm"
              >
                <div className="flex flex-col gap-1">
                  <label className="text-gray-200">Full Name *</label>
                  <input
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="rounded-lg bg-[#0B0F1F] border border-white/10 px-3 py-2 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#FF4C86]"
                    placeholder="Enter your name"
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-gray-200">Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="rounded-lg bg-[#0B0F1F] border border-white/10 px-3 py-2 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#FF4C86]"
                    placeholder="you@email.com"
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-gray-200">Phone *</label>
                  <input
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    required
                    className="rounded-lg bg-[#0B0F1F] border border-white/10 px-3 py-2 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#FF4C86]"
                    placeholder="Best number to reach you"
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-gray-200">Event Type</label>
                  <select
                    name="eventType"
                    value={form.eventType}
                    onChange={handleChange}
                    className="rounded-lg bg-[#0B0F1F] border border-white/10 px-3 py-2 text-white focus:outline-none focus:border-[#FF4C86]"
                  >
                    <option value="">Select an option</option>
                    <option value="Wedding">Wedding</option>
                    <option value="Corporate Event">Corporate Event</option>
                    <option value="Birthday / Private Party">
                      Birthday / Private Party
                    </option>
                    <option value="Brand Activation / Launch">
                      Brand Activation / Launch
                    </option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-gray-200">Event Date</label>
                  <input
                    type="date"
                    name="eventDate"
                    value={form.eventDate}
                    onChange={handleChange}
                    className="rounded-lg bg-[#0B0F1F] border border-white/10 px-3 py-2 text-white focus:outline-none focus:border-[#FF4C86]"
                  />
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-gray-200">Approx. Guest Count</label>
                  <input
                    name="guestCount"
                    value={form.guestCount}
                    onChange={handleChange}
                    className="rounded-lg bg-[#0B0F1F] border border-white/10 px-3 py-2 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#FF4C86]"
                    placeholder="e.g. 80–120 guests"
                  />
                </div>

                <div className="md:col-span-2 flex flex-col gap-1">
                  <label className="text-gray-200">Tell us about your event</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    rows={4}
                    className="rounded-lg bg-[#0B0F1F] border border-white/10 px-3 py-2 text-white placeholder:text-gray-500 focus:outline-none focus:border-[#FF4C86] resize-none"
                    placeholder="Venue, preferred booth style, timing, special requests…"
                  />
                </div>

                <div className="md:col-span-2 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                  <button
                    type="submit"
                    className="inline-flex justify-center items-center rounded-full bg-white text-[#E34364] font-semibold text-sm px-6 py-2.5 shadow-[0_16px_40px_rgba(0,0,0,0.75)] hover:bg-pink-50/90 transition"
                  >
                    Submit Request
                  </button>
                  <p className="text-[11px] text-pink-100/80">
                    By submitting, you agree to be contacted about your booking inquiry.
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
